import type {
  TargetareJob,
  TargetareSnapshotAdmin,
  TargetareSnapshotStare,
  TargetareSursaSnapshot,
} from "@/types/targetare";

export const ETICHETA_SURSA_SNAPSHOT: Record<TargetareSursaSnapshot, string> = {
  onrc: "ONRC",
  anaf: "ANAF",
  mf_bilant: "MF (bilanț)",
  nomenclator: "Nomenclator",
  lista: "Listă",
  termene: "Termene",
};

export const ETICHETA_STARE_SNAPSHOT: Record<TargetareSnapshotStare, string> = {
  in_curs: "În curs",
  activ: "Activ",
  arhivat: "Arhivat",
  esuat: "Eșuat",
};

export type TonStareSnapshot = "bun" | "atentie" | "neutru" | "rau";

export const TON_STARE_SNAPSHOT: Record<
  TargetareSnapshotStare,
  TonStareSnapshot
> = {
  in_curs: "atentie",
  activ: "bun",
  arhivat: "neutru",
  esuat: "rau",
};

export function etichetaSursaSnapshot(
  sursa: TargetareSursaSnapshot | string
): string {
  return (
    ETICHETA_SURSA_SNAPSHOT[sursa as TargetareSursaSnapshot] ?? String(sursa)
  );
}

export function etichetaStareSnapshot(
  stare: TargetareSnapshotStare | string
): string {
  return (
    ETICHETA_STARE_SNAPSHOT[stare as TargetareSnapshotStare] ?? String(stare)
  );
}

export function tonStareSnapshot(
  stare: TargetareSnapshotStare | string
): TonStareSnapshot {
  return TON_STARE_SNAPSHOT[stare as TargetareSnapshotStare] ?? "neutru";
}

export function formatContorSnapshot(
  valoare: number | null | undefined
): string {
  if (valoare === null || valoare === undefined) return "–";
  return new Intl.NumberFormat("ro-RO", { maximumFractionDigits: 0 }).format(
    valoare
  );
}

export function poateFiAplicat(
  snapshot: Pick<TargetareSnapshotAdmin, "stare">
): boolean {
  return snapshot.stare === "in_curs";
}

export function poateReveniLa(
  snapshot: Pick<TargetareSnapshotAdmin, "stare">
): boolean {
  return snapshot.stare === "arhivat" || snapshot.stare === "esuat";
}

export function snapshoturiPentruSursa(
  snapshoturi: TargetareSnapshotAdmin[],
  sursa: TargetareSursaSnapshot
): TargetareSnapshotAdmin[] {
  return snapshoturi.filter((s) => s.sursa === sursa);
}

export const ETICHETA_STARE_JOB: Record<TargetareJob["stare"], string> = {
  programat: "Programat",
  in_curs: "În curs",
  finalizat: "Finalizat",
  esuat: "Eșuat",
};

export const TON_STARE_JOB: Record<TargetareJob["stare"], TonStareSnapshot> = {
  programat: "atentie",
  in_curs: "atentie",
  finalizat: "bun",
  esuat: "rau",
};

export function etichetaStareJob(
  stare: TargetareJob["stare"] | string
): string {
  return ETICHETA_STARE_JOB[stare as TargetareJob["stare"]] ?? String(stare);
}

export function tonStareJob(
  stare: TargetareJob["stare"] | string
): TonStareSnapshot {
  return TON_STARE_JOB[stare as TargetareJob["stare"]] ?? "neutru";
}

export function snapshotActiv(
  snapshoturi: TargetareSnapshotAdmin[]
): TargetareSnapshotAdmin | null {
  return snapshoturi.find((s) => s.stare === "activ") ?? null;
}
